var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-area"},[_vm._m(0),_c('div',{staticClass:"resource-container"},[_c('resource-download',{attrs:{"resourceList":_vm.resourceList}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-header flex flex-vertical-center"},[_c('span',[_vm._v("资料下载")])])
}]

export { render, staticRenderFns }